import { atom } from 'recoil';

export const cashOutAmount = atom({
  key: 'cashOutAmount',
  default: undefined,
});
